import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'ui/Button';

import { IModal } from './Modal';
import { CloseButton, Container, Content, Footer, Header, Title, Wrapper } from './ModalElements';

const ModalPortal = ({ children, selector }: IModal.IModalPortal) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, [selector]);

  return mounted ? createPortal(children, document.querySelector(selector) as HTMLElement) : null;
};

const ModalKit = (props: IModal.IProps) =>
  props.isShow ? (
    <Wrapper>
      <Container>
        <Content className={`${props.classNameContent || ''}`}>
          <Header className={`${props.classNameHeader || ''}`}>
            {props.componentLeft && props.componentLeft}
            <Title>{props.title}</Title>
            <CloseButton className={'icon-Left-icon34'} onClick={props.onCloseModal} />
          </Header>
          {props.children}
        </Content>
        {
          <Footer>
            {props.cancelTitle && (
              <Button
                color={'gray'}
                isLinear={true}
                label={props.cancelTitle}
                onClick={props.onClickCancel}
              />
            )}
            {props.confirmTitle && (
              <Button
                label={props.confirmTitle}
                color={props.isAlert ? 'red' : 'green'}
                onClick={props.onClickConfirm}
                isLoading={props.isLoadingConfirm}
              />
            )}
          </Footer>
        }
      </Container>
    </Wrapper>
  ) : null;

const Modal = (props: IModal.IProps) =>
  props.isShow ? (
    <ModalPortal selector={'#modal-portal'}>
      <ModalKit {...props} />
    </ModalPortal>
  ) : null;

Modal.defualtProps = {
  isShow: false,
  title: '',
  onCloseModal: () => null,
  confirmTitle: '',
  cancelTitle: '',
  isAlert: false,
  onClickConfirm: () => null,
  onClickCancel: () => null,
};

export { Modal, ModalKit };
